import { useQuery, UseQueryOptions } from 'react-query'
import { connector } from '../api/connector'
import { HTTPError } from '../api/fetch/decorate-fetch'

const onError = (error) => {
  console.error(error)
}

export function useContrastQuery<TQueryVariables, TResponse>(
  queryKeys: any[],
  queryFn: (variables: TQueryVariables) => Promise<TResponse>,
  queryVariables: TQueryVariables,
  queryConfig: UseQueryOptions<TResponse> = {}
) {
  return useQuery<TResponse, HTTPError>(
    queryKeys,
    () => queryFn.call({ connector }, queryVariables),
    {
      ...queryConfig,
      // has to override, but calls back to parent
      onError: (error) => {
        onError(error)
        if (queryConfig?.onError) {
          queryConfig.onError(error)
        }
      }
    }
  )
}
